export default "__VITE_ASSET__CijWPRvL__"